import { DefaultTheme } from "styled-components";

const LightTheme: DefaultTheme = {
  colors: {
    background: "hsl(0, 0%, 98%)",
    elements: "hsl(0, 0%, 100%)",
    text: "hsl(200, 15%, 8%)",
    input: "hsl(0, 0%, 52%)",
  },
};

export default LightTheme;
